<div *ngIf="requestState">
    <div
        #chartTarget
        *ngIf="requestState"
        [ngClass]="{ 'd-none': displayMessage }"
    ></div>
</div>
